// import * as echarts from 'echarts';
// import 'echarts-gl';

import('./index.css')
import Canvas from './components/canvas/canvas'
import store from './store/store'
import canvas_config from './canvas_config'
import station_helper from './helpers/station_helper'
import OffcanvasComponent from './components/offcanvas/offcanvas_component'
import InformationCardComponent from './components/information_card/information_card'
import ProgressBar from './components/progress_bar/progress_bar'
import ModalMeasurements from './components/modal_measurements/modal_measurements'
import DataTypeButtons from './components/data_type_buttons/data_type_buttons'
import equation_store from './store/equation_store'
import measurement_helper from './helpers/measurement_helper'
import diagram_helper from './helpers/diagram_helper'
import DatePicker from './components/date_picker/date_picker'
import ConfigModal from './components/config_modal/config_modal'
import Summary from './components/summary/Summary'

let canvasComponent,informationComponent, progressBarComponent,modalMeasurementsComponent,dataTypeButtonsComponent, datePickerComponent, modalConfigComponent,summaryComponent

let reference_values = []

let TIMER = 60 //tempo em segundos para atualização

let INTERVAL

$(function(){

    moment.locale('pt-br');

    setHighchartsConfig()

    store.diagramStore.setDiagram(JSON.parse(JSON.stringify(DIAGRAM)))

    prepareStage()

    $("#canvas").html(
        '<svg id="canvas_svg" width="100%" height="100%" preserveAspectRatio="none"></svg>'
    )

    progressBarComponent = new ProgressBar({timer: TIMER})
    modalMeasurementsComponent = new ModalMeasurements()
    dataTypeButtonsComponent = new DataTypeButtons()
    datePickerComponent = new DatePicker({container: '#canvas'})
    summaryComponent = new Summary()
    datePickerComponent.generate()
    datePickerComponent.on('date-picker-change', data=>{
        // let end_d = new Date(data.end.format('YYYY/M/D HH:mm')) 

        store.mainConfigStore.setPeriod(
            data.end
        )
    })
    modalConfigComponent = new ConfigModal()
    // modalConfigComponent.showModal()
    

    setTimeout(_=>{
        progressBarComponent.generate()

        canvasComponent = new Canvas({...canvas_config})
        canvasComponent.generate()

        setStations()
        // canvasComponent.addValueBox({anchor_to:  canvasComponent.getPath('dam_2_pinheiros').getElement()})
        
        informationComponent = new InformationCardComponent()
        informationComponent.generate()
        
    },1000)

    // offcanvasComponent = new OffcanvasComponent()
    // offcanvasComponent.generate()
    
    //fechando cards informativos quando clicar na tela (ao menos que click no próprio card.. dae n fecha)
    $(document.body).on('click', e =>{
        if(!e.target.closest('.information-card-container') && e.target.id == 'canvas_svg'){
            store.informationCardStore.setBlockStatus(false)
            store.informationCardStore.setStationId()
        }
    })


    start()

    summaryComponent.generate()


    //analisando alterações nas medições para alterar informação de dado atrasado
    store.stationStore.subscribe('SET_STATION_MEASUREMENTS', data=>{
        let {station_id, measurements} = data
        let station = store.stationStore.getStation(station_id)
        if(station && station.transmission_gap){
            let status = station_helper.getDelayStatus(station.transmission_gap, measurements)
            store.stationStore.setStationDelayStatus(station_id, status)
        }

    })

    //analisando alterações nos postos para alterar informação de dado atrasado
    store.stationStore.subscribe('SET_STATIONS', data=>{
        let stations = store.stationStore.getStations()
        stations.forEach(station=>{
            if(station && station.transmission_gap && station.measurements){
                let status = station_helper.getDelayStatus(station.transmission_gap, station.measurements)
                store.stationStore.setStationDelayStatus(station.id, status)
            }
        })
    })

    //analisando a definição das equações, e recalculando por posto os valores de vazão das medições
    //as equações apenas serão consultadas no servidor no momento da inicialização da página.
    store.equationStore.subscribe('SET_EQUATIONS', equations=>{
        store.stationStore.getStations().forEach(station=>{
            let m = station_helper.calculateFlows(station.measurements,station.id)
            store.stationStore.setStationMeasurements(station.id, m)
        })
    })

    //analisando quando período é alterado, e recarregando as informações
    store.mainConfigStore.subscribe('SET_PERIOD', period=>{
        loadAll()
    })
    
    
})

const start = _ =>{
    
    if(INTERVAL){
        clearInterval(INTERVAL)
    }

    INTERVAL = setInterval(_=>{
        loadAll()
    }, TIMER * 1000)
}

const generateData = () =>{
    let array = []
    for (var x = 0; x < 10; x+=1) {
        for (var y = 0; y < 20; y+=1) {
            array.push([x, y, Math.random() * (0.51 - 0.5) + 0.5]); // Adding data with the same z value (height)
        }
      }
      return array
  }

function prepareStage(){
    const HEADER_SIZE = $("#main_header").outerHeight();
    const FOOTER_SIZE = $("#main_footer").outerHeight();
    
    $("#canvas").css({
        "height": (window.innerHeight - HEADER_SIZE - FOOTER_SIZE ),
        "min-height": (window.innerHeight - HEADER_SIZE - FOOTER_SIZE)
    })
}

const setStations = _ =>{
    store.stationStore.setStations([
        {id: 33762/*penha jusante*/},
        {id:33675 /*penha montante*/ },
        {id:33722 /*jacu*/ },
        {id:33741/*ponte dutra*/},
        {id:33767 /*mercado*/},
        {id: 33720 /*barragem móvel montante*/},
        {id:33698 /*barragem móvel jusante*/},
        {id: 33771, /*rio tiete são miguel*/},
        {id: 33673 /*santana parnaiba*/ },
        {id: 109 /*elevatória traição inferior*/},
        {id: 114 /*elevatória traição superior*/},
        {id: 156 /*Edgar de Souza Montante*/},
        {id: 92 /*Estrutura retiro*/ },
        {id: 117 /*Rio Pinheiros - Superior - Pedreira*/},
        {id: 868 /*Ponte João Dias*/},
        {id: 33758 /*Ponte do Piquerí */},
        {id: 35285 /*Baquirivu*/},
        {id: 35320 /*Itaim Biacica*/},
        {id: 35335 /*Jardim Helena*/},
        {id: 35423 /*Itaquaquecetuba*/},

        //postos pluviométricos
        {id: 33781 /*córrego franquinho*/},
        {id: 27176 /* cangaíba */},
        {id: 1345 /* ermelino matarazzo */},
        {id: 33761 /* barrage da penha */},
        {id: 1170 /*centro cemaden*/},
        {id: 1531 /*jaguaré*/},
        {id: 33697 /*CTH USP*/},
        {id: 33719 /*Barragem móvel*/},
        {id: 33212 /*Jardim Romano*/},
        {id: 33209 /*Estaleiro*/},
        
        //chuva montante penha
        {id: 1233 /*jardim luciana*/},
        {id: 1373 /*vila bartira*/},
        {id: 33217 /*jardim romano*/}
        
    ])

    store.damStore.setDams([
        {id: 1 /*barragem da penha*/},
        {id: 2 /*barragem móvel*/},
        {id: 3 /*reservatório edgar de souza*/},
        {id: 4 /*estrutura de retiro*/},
        {id: 5 /*elevatória traição*/},
        {id: 6 /*elevatória pedreira*/},
        {id: 7 /*represa guarapiranga*/},
        {id: 8 /*represa billings*/},
    ])
    
    diagram_helper.getDams().then(data=>{
        diagram_helper.getLastHoursEvents()
    })

    let stations = store.stationStore.getStations()

    for(let i = 0; i < stations.length; i += 10){
        const chunk = stations.slice(i, i+10)
        getMeasurementsOfStations(chunk)
    }

    
}

const getMeasurementsOfStations = stations =>{
    station_helper.getStationsMeasurements(stations.map(x=>x.id)).then(measurements=>{
        
        let station_ids = store.stationStore.getStations().map(x=>x.id)
        progressBarComponent.start()
        stations.map(x=>x.id).forEach(station_id=>{
            let m = measurements.measurements.filter(x=>x.station_prefix_id == station_id)

            //verificando se o tipo do posto é plu, e calculando chuva acumulada
            if(m.length > 0 && m[0].station_type_id === 2){
                //calcular valor de chuva acumulada
                m = measurement_helper.calculateAcum(m)
            }
            
            store.stationStore.setStationMeasurements(station_id, m)
        })

        station_helper.getStations(station_ids).then(stations=>{
            let copy = JSON.parse(JSON.stringify(stations))
            copy.forEach(station=>{
                let s = store.stationStore.getStation(station.id)
                // let r_v = reference_values.filter(x=> x.parameterizable_id === station.id) //valores de referencia caso já tenha
                station.measurements = s ? s.measurements : null
                station.delay_status = s ? s.delay_status : null
                station.reference_values = s ? s.reference_values : null 
                
            })

            store.stationStore.setStations(copy)

            station_helper.loading_stations = false
            // reference_values = []//limpando
        })    
        
        station_helper.getReferenceValues(station_ids).then(data=>{
            data.forEach(reference_value=>{
                let station = store.stationStore.getStation(reference_value.parameterizable_id)
                if(station){
                    store.stationStore.setStationProp(station.id, 'reference_values', reference_value)    
                } 
            })
        })

        station_helper.getEquations(station_ids).then(equations=>{
            console.log('equations', equations);
            store.equationStore.setLoading(false)
            store.equationStore.setEquations(equations)
        })
    })
}

const loadAll = () =>{

    let stations = store.stationStore.getStations()

    for(let i = 0; i < stations.length; i += 10){
        const chunk = stations.slice(i, i+10)
        // console.log(chunk);
        
        station_helper.getStationsMeasurements(chunk.map(x=>x.id)).then(measurements=>{
            progressBarComponent.start()
            store.stationStore.getStations().map(x=>x.id).forEach(station_id=>{
                let m = measurements.measurements.filter(x=>x.station_prefix_id == station_id)
                // m = station_helper.calculateFlows(m, station_id)
                
                if(m.length > 0 && m[0].station_type_id === 2){
                    //calcular valor de chuva acumulada
                    m = measurement_helper.calculateAcum(m)
                }

                if(m.length > 0){
                    store.stationStore.setStationMeasurements(station_id, m)
                }
                
            })
        }).catch(e=>{
            window.location.reload()
        })
    }
}

const setHighchartsConfig = () =>{
    var timezone = new Date().getTimezoneOffset()
    Highcharts.setOptions({
        time: {
            timezoneOffset: timezone
        },
        lang: {
            months: moment.months(), // Use Moment.js to get month names in pt-br
            weekdays: moment.weekdays(), // Use Moment.js to get weekday names in pt-br
            shortMonths: moment.monthsShort(), // Use Moment.js to get abbreviated month names in pt-br
            decimalPoint: ',',
            thousandsSep: '.',
            loading: 'Carregando...',
            noData: 'Sem dados'
        }
    });
}